import React, { useCallback, memo } from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection = memo(function HeroSection() {
  const scrollToPricing = useCallback(() => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  return <section className="pt-28 pb-12 px-4 bg-white" data-id="element-75">
      <div className="max-w-3xl mx-auto text-center" data-id="element-76">
        <h2 className="text-xl md:text-2xl font-bold text-red-600 mb-4" data-id="element-77">
          Tus hijos están creciendo ahora mismo… ¿estás creando los recuerdos
          que van a quedar para siempre?
        </h2>

        <h1 className="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight" data-id="element-78">
          ❤️ PACK 100 CITAS
          <span className="block text-2xl md:text-3xl text-blue-600 mt-2" data-id="element-79">
            Momentos Guiados para Mamá • Papá • Hijos
          </span>
        </h1>

        <button onClick={scrollToPricing} className="w-full max-w-lg mx-auto block cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-80">
          <img src="https://cdn.magicpatterns.com/uploads/jiJHpW6gAVSLfcNqG9VVLt/MOCAP_100_CITAS__1_-removebg-preview.png" alt="Pack 100 Citas" width={600} height={600} fetchPriority="high" decoding="sync" className="w-full h-auto drop-shadow-2xl mb-8" data-id="element-81" />
        </button>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-8 text-left md:text-center shadow-sm" data-id="element-82">
          <p className="text-lg md:text-xl font-bold text-gray-800 mb-2" data-id="element-83">
            Momentos reales que se convierten en recuerdos para toda la vida.
          </p>
          <p className="text-gray-700 font-medium" data-id="element-84">
            Sin pantallas. Sin planificar nada. Solo abrís, elegís una cita y
            conectás de verdad con tus hijos.
          </p>
        </div>

        <div className="mt-8 max-w-md mx-auto" data-id="element-85">
          <CTAButton text="👉 QUIERO CREAR RECUERDOS CON MIS HIJOS" subtext="Descarga inmediata • Garantía de 7 días" size="sm" data-id="element-86" />
        </div>
      </div>
    </section>;
});